import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetUberDirectLatestSignatureStatusOnEditDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useFetchLatestUberSignature = () => {
  const [getLatestUberSignature, { data, called, loading }] = useLazyQuery(
    GetUberDirectLatestSignatureStatusOnEditDocument,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    getLatestUberSignature();
  }, [getLatestUberSignature]);

  const latestUberSignature = data ? getMe(data)?.organization.company.latestUberSignature : null;
  const availableUber = latestUberSignature?.status == 'approved';

  return { loading: !called || loading, availableUber };
};
